/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M6 18.75a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H6ZM5.25 12a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 0C3.3432 0 2 1.3432 2 3v18c0 1.6569 1.3432 3 3 3h14c1.6569 0 3-1.3431 3-3V3c0-1.6568-1.3431-3-3-3H5ZM3.5 21v-4.5h17V21c0 .8284-.6716 1.5-1.5 1.5H5c-.8284 0-1.5-.6716-1.5-1.5Zm17-6h-17V9h17v6ZM6 3.75a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H6Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuStorageFilled'
);
